import { emptySplitApi, RootState } from 'shared/store/store'

import { getActiveClient } from 'shared/store/clients/selectors'
import { ICommonListModel } from 'shared/models/Common'
import {
  IBuildingDetail,
  IBuildingFilterModel,
  IBuildingSingleResult,
} from 'Modules/HousingAssociation/CompanyInfo/shared/models/Buildings'
import { axiosErrorMessageHelper } from 'shared/utils/axiosErrorMessageHelper'
import {
  IUnitQueryModel,
  IUnitResponseModel,
} from 'Modules/HousingAssociation/OurCompany/shared/models/Unit'

const buildingsService = emptySplitApi.injectEndpoints({
  endpoints: (build) => ({
    fetchBuildings: build.query<ICommonListModel<IBuildingSingleResult>, void>({
      queryFn: async (_args, api, _extra, query) => {
        const state = api.getState() as RootState
        const client = getActiveClient(state)
        // @ts-expect-error todo companyinfo does not exist
        const filters = state.companyInfo.buildings.filters

        if (!client) throw Error('No client available')

        const response = await query({
          url: `hu/Building/client/${client.id}`,
          method: 'POST',
          headers: {
            'x-api-version': '2.0',
          },

          data: filters as IBuildingFilterModel,
        })

        if (response.error) return { error: response.error }
        return {
          data: response.data as ICommonListModel<IBuildingSingleResult>,
        }
      },
    }),

    fetchBuildingDetails: build.query<IBuildingDetail, number>({
      queryFn: async (arg, _api, _extraOptions, query) => {
        const buildingId = arg
        const res = await query({
          url: `hu/building/${buildingId}`,
          method: 'GET',
          headers: { 'x-api-version': '2.0' },
        })

        if (res.error) return { error: res.error }
        return { data: res.data as IBuildingDetail }
      },
    }),
    fetchAllBuildings: build.query<IBuildingSingleResult[], void>({
      queryFn: async (_args, api, _extraOptions, query) => {
        const state = api.getState() as RootState
        const client = getActiveClient(state)

        if (!client) throw Error('No client available')

        const res = await query({
          url: `hu/Building/for-client/${client.id}`,
          method: 'GET',
          headers: { 'x-api-version': '2.0' },
        })

        if (res.error) {
          const error = axiosErrorMessageHelper(res.error, {
            fallbackError: 'En feil har oppstått i henting av bygninger.',
          })
          return { error }
        }
        return { data: res.data as IBuildingSingleResult[] }
      },
    }),
    fetchUnits: build.query<IUnitResponseModel, IUnitQueryModel>({
      queryFn: async (filters, api, _extraOptions, query) => {
        const state = api.getState() as RootState
        const client = getActiveClient(state)

        if (!client) throw Error('No client available')
        const res = await query({
          url: `hu/client/${client.id}/units`,
          method: 'POST',
          headers: { 'x-api-version': '2.0' },
          data: filters as IUnitQueryModel,
        })
        if (res.error) {
          const error = axiosErrorMessageHelper(res.error, {
            fallbackError: 'En feil har oppstått i henting av bygninger.',
          })
          return { error }
        }
        return { data: res.data as IUnitResponseModel }
      },
    }),
  }),

  overrideExisting: false,
})

export default buildingsService
export const {
  useFetchBuildingsQuery,
  useLazyFetchBuildingDetailsQuery,
  useFetchAllBuildingsQuery,
  useFetchUnitsQuery,
} = buildingsService
